import * as React from 'react';
import * as PXBlueCore from '@brightlayer-ui/react-components/core';
import { MetricHero } from '../MetricHero';
import { ChannelDatum } from '../../types';

export const MetricHeroes: React.FC<{
    channelData: ChannelDatum[];
}> = (props) => (
    <div data-testid="metric-hero">
        <PXBlueCore.HeroBanner style={{ maxWidth: '200px' }}>
            {props.channelData.map((channelDatum, index) => (
                <MetricHero key={index} channelDatum={channelDatum} />
            ))}
        </PXBlueCore.HeroBanner>
    </div>
);
